import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import MainLayout from '../../Layout/MainLayout';
import { ProfileProvider, useProfile } from '../../context/profile/ProfileContext';
import ProfileHeader from './sections/Header/ProfileHeader';
import SubscriptionBanners from './sections/Subscription/sections/SubscriptionBanners';
import AccountTab from './sections/Account/AccountTab';
import BusinessTab from './sections/Business/BusinessTab';
import SubscriptionTab from './sections/Subscription/SubscriptionTab';
import ProfileModals from './sections/Modals/ProfileModals';

const containerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.2 } }
};

const ProfileContent = () => {
  const { activeTab } = useProfile();

  return (
    <div className="max-w-7xl mx-auto p-3 sm:p-4 md:p-6 space-y-5 sm:space-y-6 pb-12 animate-page-entry font-sans">
      {/* Dynamic Page Header & Navigation Tabs */}
      <ProfileHeader />

      {/* Global Banners for Subscription Status */}
      <SubscriptionBanners />

      {/* Main Content Area */}
      <div className="w-full">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            {/* Account Tab */}
            {activeTab === 'account' && <AccountTab />}

            {/* Business Tab */}
            {activeTab === 'business' && <BusinessTab />}

            {/* Subscription Tab */}
            {activeTab === 'subscription' && <SubscriptionTab />}
          </motion.div>
        </AnimatePresence>

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-4 px-8 text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-widest text-center md:text-left">
          <span>Trrip Company ID: {localStorage.getItem('agent_id')?.slice(0, 8)}...</span>
          <span className="flex items-center gap-2">
            <ShieldCheck size={14} className="text-[#067978]" /> Encrypted Data
          </span>
        </div>
      </div>

      {/* Modals */}
      <ProfileModals />
    </div>
  );
};

const ProfilePage = () => {
  return (
    <ProfileProvider>
      <MainLayout>
        <ProfileContent />
      </MainLayout>
    </ProfileProvider>
  );
};

export default ProfilePage;
